export default {
  title: 'New mask',
  title_edit: 'Editing mask',
  help: 'Help',
  howToTitle: 'How to create mask patterns',
  forNumbers: 'For numbers',
  forLetters: 'For letters',
  forAlphanumeric: 'For alphanumeric',
  name: 'Name*',
  pattern: 'Mask*',
  playground: 'Playground',
  applied: '(applied: {{pattern}})'
}
